module.exports = __webpack_public_path__ + "img/27.41f676aa.png";